import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

export interface PdfViewerDialogData {
  url: string;
  title?: string;
}

@Component({
  selector: "app-pdf-viewer",
  templateUrl: "./pdf-viewer.component.html",
  styleUrls: ["./pdf-viewer.component.scss"],
})
export class PdfViewerComponent implements OnInit {
  title = "Document";
  safeUrl: SafeResourceUrl | null = null;
  loadError = false;

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<PdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PdfViewerDialogData
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title || "Document";
    const url = (this.data?.url || "").trim();
    if (!url) {
      this.loadError = true;
      return;
    }
    // Native browser PDF viewer inside the app dialog
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openExternally(): void {
    if (this.data?.url) {
      window.open(this.data.url, "_blank", "noopener");
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
